module.exports = __webpack_public_path__ + "img/knee.d4f9753a.png";